import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PaymentDetailSection from "../sections/PaymentDetailSection";

interface Props {
  id: string;
}

const PaymentDetail = (props: Props) => {
  //translations
  const { t } = useTranslation("shared\\moduleNames");

  const { id } = useParams<Props>();

  return (
    <>
      <Header
        title={t("paymentDetail.title")}
        includeBreadcrumbs
        links={[{ text: t("payments.title"), to: "/payments" }]}
      />
      <ModuleContent>
        <PaymentDetailSection paymentId={id} />
      </ModuleContent>
    </>
  );
};

export default PaymentDetail;
